import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import routeRegister from 'helpers/routeRegister';
import { selectors } from '../reducers/impostazioniCpa';
import helper from 'helpers/steinerHelper';

const routes = helper.generateRoutes('impostazioniCpa', selectors);
routes.list.list.breadcrumb = `Portali Indicatori`;

const list = _.values(routes.list).map(route => ({
    ...route,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'impostazioniCpa' */ `modules/impostazioniCpa/${route.componentPath}`)
                .then(response => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('impostazioniCpa', routes.patterns);
routeRegister.addLinks('impostazioniCpa', links);

export default list;